import React from 'react'
import TopHeader from '../Header/TopHeader'
import Navbar from '../Header/Navbar'
import Footer from '../Footer/Footer'
import '../Css/Contact.css'

function Contact() {
    return (
        <>
            <TopHeader />
            <Navbar />
            <section style={{ background: "white", padding: "15px" }}>
                <div class="section-header">
                    <div class="container">
                        <h2 style={{ color: "#115886", fontFamily: "poppins", fontSize: "1.6rem" }}>Contact Us</h2>
                    </div>
                </div>

                <div class="container">
                    <div class="row" style={{ display: "flex" }}>
                        <div class="contact-info">
                            <div class="contact-info-item">
                                <div class="contact-info-content" >
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Address</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>1st Floor, D 159, D Block, Sector 7, Noida, Uttar Pradesh 201301<br />
                                        </p>
                                </div>
                            </div>
                            <div class="contact-info-item">
                                <div class="contact-info-content">
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Landline No</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>+91 11 4760 2267</p>
                                </div>
                                <div class="contact-info-content">
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Mobile No</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>+91 9625758585</p>
                                </div>
                            </div>
                            <div class="contact-info-item">
                                <div class="contact-info-content">
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Email</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>INFO@COMPLIANCEKARE.COM</p>
                                </div>
                            </div>
                        </div>
                        <div class="contact-form">
                            <form action="" id="contact-form">
                                <h2 style={{ color: "rgb(137, 199, 100)" }}>Send Message</h2>
                                <div class="input-box">
                                    <input type="text" required="true" name="" />
                                    <span>Full Name</span>
                                </div>

                                <div class="input-box">
                                    <input type="email" required="true" name="" />
                                    <span>Email</span>
                                </div>

                                <div class="input-box">
                                    <textarea required="true" name=""></textarea>
                                    <span>Type your Message...</span>
                                </div>

                                <div class="input-box">
                                    <input type="submit" value="Send" name="" />
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Contact